import { render, staticRenderFns } from "./reseatLogin.vue?vue&type=template&id=8151e9f0&scoped=true"
import script from "./reseatLogin.vue?vue&type=script&lang=js"
export * from "./reseatLogin.vue?vue&type=script&lang=js"
import style0 from "./reseatLogin.vue?vue&type=style&index=0&id=8151e9f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8151e9f0",
  null
  
)

export default component.exports